import { MenuMore } from "@design-system/Menu/MenuMore";
import type { MenuMoreProps } from "@design-system/Menu/Menu.types";
import { useBoardCardTabStop } from "./boardCardFocus";

/**
 * The "More actions" menu for `BoardCardLayout`'s `menu` slot: a 20px
 * `MenuMore` that Tab reaches from its own focused card only.
 */
export const BoardCardMenu = (
    props: Readonly<Omit<MenuMoreProps, "size" | "tabIndex">>,
) => {
    const { tabIndex } = useBoardCardTabStop();
    return <MenuMore {...props} size="xs" tabIndex={tabIndex} />;
};
